export enum CompanyType {
  SUPERADMIN = 'superadmin',
  MAIN = 'main',
  FLEET = 'fleet',
  CORPORATE = 'corporate',
  BUTTON = 'button'
}

export interface IModule {
  id: number;
  name: string;
  slug: string;
  description?: string;
  isActive: boolean;
  isGroup: boolean;
  companyTypes?: CompanyType[];
  routePath?: string;
  icon?: string;
  sortOrder: number;
  parentId?: number;
  parent?: IModule;
  children?: IModule[];
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class Module {
  id: number;
  name: string;
  slug: string;
  description?: string;
  isActive: boolean;
  isGroup: boolean;
  companyTypes?: CompanyType[];
  routePath?: string;
  icon?: string;
  sortOrder: number;
  parentId?: number;
  parent?: Module;
  children?: Module[];
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IModule) {
    this.id = data.id;
    this.name = data.name;
    this.slug = data.slug;
    this.description = data.description;
    this.isActive = data.isActive ?? true;
    this.isGroup = data.isGroup ?? false;
    this.companyTypes = data.companyTypes || [];
    this.routePath = data.routePath;
    this.icon = data.icon;
    this.sortOrder = data.sortOrder ?? 0;
    this.parentId = data.parentId;
    this.parent = data.parent ? new Module(data.parent) : undefined;
    this.children = data.children?.map(child => new Module(child)) || [];
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }

  get displayName(): string {
    return this.name;
  }

  get statusLabel(): string {
    return this.isActive ? 'Active' : 'Inactive';
  }
}
